@if (isResultsEnvironment()) {
	@if (availableFunctionalGroups().length > 0) {
		<div class="filter-group">
			<label class="filter-label" for="functional-group-select">Functional group</label>
			<p-select
				inputId="functional-group-select"
				[options]="fgOptions()"
				[(ngModel)]="selectedFg"
				optionLabel="name"
				[filter]="true"
				filterPlaceholder="Search..."
				[style]="{ width: '100%' }"
				data-testid="group-filter-functional-group-select"
			/>
		</div>
	}

	@if (availableOrgGroups().length > 0) {
		<div class="filter-group">
			<label class="filter-label" for="org-group-select">Group</label>
			<p-select
				inputId="org-group-select"
				[options]="ogOptions()"
				[(ngModel)]="selectedOg"
				optionLabel="name"
				[filter]="true"
				filterPlaceholder="Search..."
				[style]="{ width: '100%' }"
				data-testid="group-filter-org-group-select"
			/>
		</div>
	}
}
